module.exports = __webpack_public_path__ + "static/login-background.jpeg";